import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projects } from '../data/projectsData';
import './Portfolio.css';

function Portfolio() {

  return (
    <div className="portfolio">
      <div className="portfolio-container">
        <motion.div
          className="portfolio-header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease: [0.4, 0, 0.2, 1] }}
        >
          <h1 className="portfolio-title">Portfolio</h1>
          <div className="portfolio-decorative-line"></div>
        </motion.div>
        <div className="portfolio-grid">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ 
                duration: 1, 
                delay: index * 0.1,
                ease: [0.4, 0, 0.2, 1]
              }}
            >
              <Link 
                to={`/project/${project.id}`}
                className="portfolio-item"
              >
                <motion.div 
                  className="portfolio-image-wrapper"
                  whileHover={{ scale: 1.03 }}
                  transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                >
                  <img 
                    src={project.coverImage || project.image} 
                    alt={project.title}
                    className="portfolio-image"
                  />
                </motion.div>
                <div className="portfolio-info">
                  <h2 className="portfolio-item-title">{project.title}</h2>
                  <p className="portfolio-item-meta">
                    {project.context}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;

